// extracted by mini-css-extract-plugin
module.exports = {"DeprecationNotice":"DeprecationNotice_DeprecationNotice__2uG_E","DeprecationNoticeContent":"DeprecationNotice_DeprecationNoticeContent__32Hjh"};